import { Location } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionKey } from "@shared/clickar-constants";
import { ObservedAuctionDTO } from "@shared/model/auction.model";
import { ApiService } from "@shared/services/api.service";
import { MqttService } from "@shared/services/mqtt/mqtt.service";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";

@Component({
	selector: "app-live-auction",
	templateUrl: "./live-auction.component.html",
	styleUrl: "./live-auction.component.scss",
	standalone: false
})
export class LiveAuctionComponent implements OnInit, OnDestroy {
	nowTime: Date;
	timer;
	idAuction: number;
	userid: number;
	observed: ObservedAuctionDTO;
	auctionEngineDate;

	constructor(
		private mqttService: MqttService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private storageService: StorageManagerService,
		private utils: ClickarUtilsService,
		private _location: Location,
		private apiService: ApiService
	) {
		activatedRoute.params.subscribe(value => {
			this.idAuction = value["idAuction"];

			if (this.utils.isNullOrUndefined(this.idAuction)) {
				this.router.navigate(["/"]);
			}
		});
	}

	goBack() {
		this._location.back();
	}

	ngOnInit() {
		this.apiService.getTimeUsingGET().subscribe(value => {
			this.auctionEngineDate = value + 500; //recover RTT with 500 ms
		});
		this.utcTime();

		this.userid = this.storageService.getSessionItem(SessionKey.USER_ID, null);

		this.mqttService.connect().subscribe(() => {
			this.apiService.getObservedAuctionLotUsingPOST(this.idAuction)
				.subscribe(value => {
					this.observed = value;
				});
		});
	}

	utcTime(): void {
		this.timer = setInterval(() => {
			if (this.auctionEngineDate) {
				this.nowTime = new Date(this.auctionEngineDate += 1e3);
			}
		}, 1e3);
	}

	ngOnDestroy(): void {
		this.mqttService.disconnect();
		clearInterval(this.timer);
	}
}